import { getCookieValue } from 'components/analytics/utils';
import { ANON_ID_COOKIE, CHIME_USER_ID_COOKIE } from 'utils/cookies';
import { isBrowser } from 'utils/environment';

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

/**
 * Events forwarded directly into the GTM dataLayer. The GTM-N3Z9ZNR
 * container keys its custom-event triggers on these names.
 */
export const GTM_DESTINATION_EVENTS = new Set([
  'FAQ Arrow Clicked',
  'Floating Disclaimer Shown',
  'Landing Page Email Filled',
  'Lead Generation Interaction Captured',
  'Login Link Tapped',
  'Module Viewed',
  'Scroll Depth',
  'Slider Bar Clicked',
  'Visitor ID Set',
]);

// Include `userId` only when the caller is identified, never when anonymous.
// The @1debit/analytics SDK writes the identified user ID to `chime_user_id`
// on identify (scoped *.chime.com), so reading the cookie at push time picks
// up any user identified anywhere on the chime.com surface.
export function pushGtmEvent(eventName: string, properties: object = {}): void {
  if (!isBrowser() || !eventName) return;

  const userId = getCookieValue(CHIME_USER_ID_COOKIE);
  const dataLayer = (window.dataLayer ||= []);
  dataLayer.push({
    ...(userId ? { userId } : {}),
    ...properties,
    segmentAnonymousId: getCookieValue(ANON_ID_COOKIE),
    event: eventName,
  });
}

/**
 * Tracks an event to GTM. Only GTM_DESTINATION_EVENTS are pushed — the GTM
 * container only triggers on those names, so anything else would be noise in
 * the dataLayer.
 */
export function trackGtmEvent(eventName: string, properties: object = {}): void {
  if (!GTM_DESTINATION_EVENTS.has(eventName)) return;

  pushGtmEvent(eventName, properties);
}
